import { createReducer, on } from '@ngrx/store';
import { SearchAtletaResponse, Sport } from '@libs/entity-lib';
import * as fromSportCenter from './sport-center.actions';

export interface State {
  loading: boolean;
  sports: Sport[];
  searchAtleta: SearchAtletaResponse | null;
  isBlock: boolean;
  error: any | null;
}

export const initialState: State = {
  loading: false,
  sports: [],
  searchAtleta: null,
  error: null,
  isBlock: false,
};

export const reducer = createReducer(
  initialState,
  on(fromSportCenter.fetchSportsByIdProvideCourtSuccess, (state, { sports }) => ({
    ...state,
    sports,
  })),
  on(fromSportCenter.fetchAtletaByCellphoneSuccess, (state, { searchAtleta }) => ({
    ...state,
    searchAtleta,
  })),

  on(fromSportCenter.postEventRent, (state) => ({ ...state, loading: true })),
  on(fromSportCenter.postEventRentSuccess, (state) => ({ ...state, loading: false })),
  on(fromSportCenter.fetchFailedDefault, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(fromSportCenter.fetchFailedDefault, (state, { error }) => ({ ...state, error })),
  on(fromSportCenter.setLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),

  on(fromSportCenter.fetchBlockAthleteWebsite, (state) => ({ ...state, loading: true })),
  on(fromSportCenter.fetchBlockAthleteWebsiteSuccess, (state, { isBlock }) => ({
    ...state,
    loading: false,
    isBlock,
  })),
  on(fromSportCenter.fetchBlockAthleteWebsiteFailed, (state, { error }) => ({ ...state, error })),

  on(fromSportCenter.blockAthleteWebsite, (state) => ({ ...state, loading: true })),
  on(fromSportCenter.blockAthleteWebsiteSuccess, (state, { isBlock }) => ({
    ...state,
    loading: false,
    isBlock,
  })),
  on(fromSportCenter.blockAthleteWebsiteFailed, (state, { error }) => ({ ...state, error }))
);
